module.exports = __webpack_public_path__ + "assets/img/00.7030c9f1.png";